import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1LinkTheme: Components<Theme>['MuiLink'] = {
    defaultProps: {
        underline: 'hover',
        color: 'primary',
        variant: 'body1',
    },
    styleOverrides: {
        root: ({ theme }) => ({
            textDecorationColor: 'initial',
            ...(theme.palette.mode === 'dark' && {
                color: theme.palette.text.primary,
            }),
        }),
    },
}
